export enum Tier {
  Essential = 'Essential',
  Pro = 'Pro',
  Success = 'Success',
}

export class TierAccess {
  isProfilesAllowed: boolean;
  isVisitsAllowed: boolean;
  isReferralsAllowed: boolean;
  isInterestProfilesAllowed: boolean;
  isCouponsAllowed: boolean;
  isAutomationsAllowed: boolean;
  isPerformanceAnalyticsAllowed: boolean;
  isSalesAnalyticsAllowed: boolean;
  isAudiencesLimited: boolean;
  isScriptsAllowed: boolean;
  isFontUploadAllowed: boolean;
  isActivityLogAllowed: boolean;
  isEmbeddedPlaceholdersAllowed: boolean;
  isLoggedInDetectionAllowed: boolean;
  maxActiveDimensions: number;
  /** How far back Visits reaches; an account's `eventRetention.standardTtlDays` replaces it. */
  visitsWindowDays: number;

  constructor(public tier: Tier) {
    this.isProfilesAllowed = tier !== Tier.Essential;
    this.isVisitsAllowed = tier !== Tier.Essential;
    this.isInterestProfilesAllowed = tier !== Tier.Essential;
    this.isReferralsAllowed = tier !== Tier.Essential;
    this.isCouponsAllowed = true;
    this.isAutomationsAllowed = tier !== Tier.Essential;
    this.isSalesAnalyticsAllowed = tier !== Tier.Essential;
    this.isPerformanceAnalyticsAllowed = tier !== Tier.Essential;
    this.isAudiencesLimited = tier === Tier.Essential;
    this.isScriptsAllowed = tier !== Tier.Essential;
    this.isFontUploadAllowed = tier !== Tier.Essential;
    this.isActivityLogAllowed = tier !== Tier.Essential;
    this.isEmbeddedPlaceholdersAllowed = tier !== Tier.Essential;
    this.isLoggedInDetectionAllowed = tier !== Tier.Essential;
    this.maxActiveDimensions = tier === Tier.Essential ? 1 : tier === Tier.Pro ? 2 : 4;
    this.visitsWindowDays = tier === Tier.Essential ? 1 : tier === Tier.Pro ? 7 : 30;
  }
}
